import React from "react"
import { UseSearchReturn } from "./use-search"
import { SearchContext } from "./use-search-context"
import { Provider } from "react-redux"
import SearchReduxContext from "./search-redux-context"

export default function SearchProvider({
  children,
  store,
  ...props
}: React.PropsWithChildren<UseSearchReturn>) {
  return (
    <SearchContext.Provider value={props}>
      <Provider store={store} context={SearchReduxContext}>
        {children}
      </Provider>
    </SearchContext.Provider>
  )
}
